<template>
  <div class="download-prompt" v-if="!is_mobile && show && !$isElectron && !$route.query.hide_menu">
    <div class="popover-menu wrap">
      <div class="download-prompt__title">
        <div>{{ $t('components.download.title') }}</div>
        <div class="close" @click="close">
          <svg-icon iconClass="close"></svg-icon>
        </div>
      </div>
      <div class="download-prompt__body">
        <p>{{ $t('components.download.body.content') }}</p>
        <div class="download-prompt__button">
          <button @click="download" v-baidu-event-tracking="{ feature: '下载客户端', action: '侧边栏引导' }">
            {{ $t('components.download.body.btn') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { downloadApps } from '../utils/utils'

export default {
  name: 'DownloadPrompt',
  data() {
    return {
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640,
    }
  },
  computed: {
    show() {
      return this.$store.state.downloadPrompt == 1
    },
  },
  methods: {
    download() {
      this.close()
      downloadApps()
    },
    close() {
      this.$store.commit('setDownloadPrompt', 0)
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.is_mobile = this.$isMobile() || document.body.clientWidth <= 640
    })
  },
}
</script>
<style lang="scss" scoped>
.download-prompt {
  position: fixed;
  font-size: 12px;
  background: var(--glassBg);
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  border-radius: 6px;
  width: 204px;
  z-index: 999;
  bottom: 20px;
  margin-left: 20px;

  .wrap {
    padding: 12px;
    .download-prompt__title {
      font-size: 12px;
      color: var(--textBlack);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .close {
        cursor: pointer;
        width: 16px;
        height: 16px;
        border-radius: 3px;
        text-align: center;
        svg {
          width: 8px;
          height: 8px;
        }
        &:hover {
          background: var(--hoverBg);
        }
      }
    }
    .download-prompt__body {
      margin-top: 8px;
      p {
        font-weight: 400;
        color: var(--textGray);
      }
      .download-prompt__button {
        button {
          border: none;
          font-size: 12px;
          cursor: pointer;
          color: var(--textGray);
          text-decoration: underline;
          margin-top: 4px;
          background: unset;
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .download-prompt {
    margin: 0 20px;
  }
}
</style>
